/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Showcase_TryInputs */

const en_landing_showcase_try = /** @type {(inputs: Landing_Showcase_TryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this prompt`)
};

const zh_landing_showcase_try = /** @type {(inputs: Landing_Showcase_TryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用这个提示词`)
};

/**
* | output |
* | --- |
* | "Use this prompt" |
*
* @param {Landing_Showcase_TryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_showcase_try = /** @type {((inputs?: Landing_Showcase_TryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Showcase_TryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_showcase_try(inputs)
	return zh_landing_showcase_try(inputs)
});
export { landing_showcase_try as "landing.showcase.try" }